import type { ConfigurationSectionDefinition } from '@/app/types/aql-configuration';

export const CONFIGURATION_SECTIONS: ConfigurationSectionDefinition[] = [
  {
    id: 'client',
    label: 'Clientes',
    title: 'Clientes',
    subtitle: 'Identidade do cliente e contexto principal de operação.'
  },
  {
    id: 'projects',
    label: 'Projetos',
    title: 'Projetos',
    subtitle: 'Projetos operacionais por cliente, incluindo código de acesso, especie e fase.'
  },
  {
    id: 'locations',
    label: 'Localizações',
    title: 'Localizações',
    subtitle: 'Instalações físicas com morada, coordenadas e ligação ao cliente/projeto.'
  },
  {
    id: 'zones',
    label: 'Áreas operacionais',
    title: 'Áreas operacionais',
    subtitle: 'Áreas físicas monitorizadas, com contexto operacional e unidades associadas.'
  },
  {
    id: 'kits',
    label: 'Unidades Edge',
    title: 'Unidades Edge',
    subtitle: 'Unidades AQL associadas a áreas operacionais, câmaras, sensores e automação.'
  },
  {
    id: 'cameras',
    label: 'Cameras',
    title: 'Cameras',
    subtitle: 'Camera sources attached to kits and positioned in the operation.'
  },
  {
    id: 'ultrasound',
    label: 'Ultrassons',
    title: 'Ultrassons',
    subtitle: 'Equipamentos US associados a kits para ativar o echogram no live preview.'
  },
  {
    id: 'sensors',
    label: 'Limites sensores',
    title: 'Limites sensores',
    subtitle: 'Limites simples para temperatura, pH, oxigénio dissolvido e salinidade.'
  },
  {
    id: 'vision-copilot',
    label: 'VISION COPILOT',
    title: 'VISION COPILOT',
    subtitle: 'Controlo do agente Gemini, modo sentinela, prompt, orçamento e cadência de análise.'
  },
  {
    id: 'species-phases',
    label: 'Species & Phases',
    title: 'Species & Phases',
    subtitle: 'Biological context used across detections, growth and biomass.'
  },
  {
    id: 'thresholds',
    label: 'Thresholds & Rules',
    title: 'Thresholds & Rules',
    subtitle: 'Central project defaults for environmental interpretation and escalation.'
  },
  {
    id: 'users',
    label: 'Users & Access',
    title: 'Users & Access',
    subtitle: 'Operational access by role, project context and recent activity.'
  },
  {
    id: 'personalization',
    label: 'Personalização',
    title: 'Personalização',
    subtitle: 'Tema, idioma e ordenação do menu lateral. Preferências pessoais de interface.'
  }
];
